import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabasePublishableKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const clientKey = supabasePublishableKey || supabaseAnonKey;
const isConfigured = Boolean(supabaseUrl && clientKey);

if (!isConfigured && process.env.NODE_ENV !== 'test') {
  // Keep runtime warning explicit for missing environment values.
  // eslint-disable-next-line no-console
  console.warn('Missing Supabase environment variables.');
}

const fallbackUrl = 'http://localhost:54321';
const fallbackAnonKey = 'public-anon-key-placeholder';

export const supabase = createClient(
  supabaseUrl || fallbackUrl,
  clientKey || fallbackAnonKey
);

export const isSupabaseConfigured = isConfigured;
